import { List } from 'immutable';
import { lruMemoize } from 'reselect';

const isSalesAndMarketingTaxonomyLoading = lruMemoize(
    (data) => data.get('loaded') === 'loading',
);

const getSalesAndMarketingTaxonomyCategories = lruMemoize(
    (data) => data.getIn(['catSalesAndMarketing', 'categories'], List()),
);

export {
    isSalesAndMarketingTaxonomyLoading,
    getSalesAndMarketingTaxonomyCategories,
};
